<template>
  <div>
    <b-card no-body>
      <b-card-header
        header-bg-variant="outline-secondary"
        header-tag="header"
        class="p-0"
        role="tab"
      >
        <h6 class="mb-0 p-1 titulo_ait" align="left">
          {{ tituloPossuidor }}
        </h6>
      </b-card-header>
      <b-row class="ml-0">
        <b-col sm="4">
          <b-form-group
            label="Nome"
            label-size="sm"
            label-class="text-secondary"
          >
            <span class="font-weight-bold">
              {{ temValor(ocultarNome(possuidor.nome)) }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="p-2">
        <b-col>
          <b-card no-body>
            <b-card-header
              header-bg-variant="outline-secondary"
              header-tag="header"
              class="p-0"
              role="tab"
            >
              <h6 class="mb-0 p-1 titulo_ait" align="left">
                SNE - Sistema de Notificação Eletrônica
              </h6>
            </b-card-header>
            <b-row class="ml-0">
              <b-col sm="4">
                <b-form-group
                  label="Adesão"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span class="font-weight-bold">
                    {{
                      temValor(obterStatusSimNao(
                        possuidor.ind_adesao_veiculo_sne)
                      )
                    }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label="Cód. Adesão Veículo"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span class="font-weight-bold">
                    {{ temValor(possuidor.sne_indicador_adesao_veiculo) }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label="Data Adesão"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span class="font-weight-bold">
                    {{
                      temValor(dataBrasil(possuidor.data_adesao_veiculo_sne))
                    }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { helperDatas } from "@/helpers";
import helpers from "@/helpers";
import PessoaAutoInfracaoTransito from "@/models/PessoaAutoInfracaoTransito";

export default {
  name: "PessoaAit",

  components: {},

  props: {
    pessoa: {
      type: Object,
      default: function () {
        return new PessoaAutoInfracaoTransito();
      },
    },
    tituloPossuidor: {
      type: String,
      default: "",
    },
  },

  watch: {
    pessoa() {
      this.possuidor = this.pessoa;
    },
  },

  data() {
    return {
      possuidor: new PessoaAutoInfracaoTransito(),
    };
  },

  methods: {
    obterStatusSimNao(status) {
      return status ? "Sim" : "Não";
    },
    temValor(valor) {
      return valor ? valor : "-";
    },

    ocultarNome(valor) {
      return helpers.ocultarLetras(valor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    verificarAdesao(dado) {
      if (dado) {
        return "Sim";
      } else {
        return "Não";
      }
    },
  },

  mounted() {
    this.possuidor = this.pessoa;
  },
};
</script>

<style scoped>
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>